// import { host } from '@/assets/js/http'

// initial state
const state = {
  userInfo: {
    userName: '苏思洋',
    avatar: 'http://img3.a0bi.com/upload/ttq/20140813/1407915088900.jpg'
  },
  whitelist: ['/welcome', '/401', '/404'],
  list: []
}

const actions = {
  showUser ({ commit, state }) {
    var name = 'apusLoginInfo'
    var arr; var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    arr = document.cookie.match(reg)
    if (arr === undefined || arr == null) {
      // var random = Date.now()
      // location.href = host + '/sso.htm?t='+random;
      return
    }
    commit('showUserMutation', arr[2], !state.collapse)
  }
}

const mutations = {
  showUserMutation (state, userName, val) {
    state.userInfo.userName = userName
  },
  setPermiList (state, list) {
    state.list = list
    console.log('list: ', list)
  }
}

// getters
const getters = {
  userInfo: state => state.userInfo,
  allPermiList: state => state.list.map(({ url }) => url).concat(state.whitelist)
}

export default {
  state,
  mutations,
  actions,
  getters
}
